module.exports = __webpack_public_path__ + "img/diagrama_seicti_2023.64285e75.png";